var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { fontSizes, fontWeights, spacing, } from "syf-component-library/defaultTheme";
import { Link } from "syf-component-library/ui/atoms";
import { Body } from "syf-component-library/ui/typography";
export var CertificateLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", "px;\n  font-weight: ", ";\n  padding: 0;\n"], ["\n  font-size: ", "px;\n  font-weight: ", ";\n  padding: 0;\n"])), fontSizes.root, fontWeights.bold);
export var FamilyStores = styled(Body)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: ", "px;\n"], ["\n  margin-top: ", "px;\n"])), spacing.base);
var templateObject_1, templateObject_2;
